import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { TestEvent } from "@/api/williams/testEvents";
import { useQuery } from "react-query";

export function useAdvisories(event: TestEvent) {
  return useQuery({
    enabled: Boolean(event.project?.id),
    queryKey: queryKeys.testEvent.advisories(event),
    queryFn: () => api.getAdvisories(event),
    // Stops flicker when updating advisories.
    keepPreviousData: true,
  });
}
